import { useDisplay } from "@/context/DisplayContext";
import { Minus, Plus, Sun, Moon, TextAa } from "@phosphor-icons/react";

// Accessibility display controls: font size A-/A+ and light/dark theme toggle.
// Rendered in both the public and signed-in headers so it appears on every page.
export default function DisplayControls({ className = "" }) {
  const { dark, toggleDark, fontStep, incFont, decFont, maxStep } = useDisplay();
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="display-controls">
      <div className="flex items-center rounded-full border border-border bg-card">
        <button
          onClick={decFont}
          disabled={fontStep === 0}
          aria-label="Decrease text size"
          title="Smaller text"
          className="grid h-9 w-9 place-items-center rounded-l-full text-foreground transition-colors hover:bg-accent disabled:opacity-40"
          data-testid="display-font-decrease"
        ><Minus size={16} weight="bold" /></button>
        <span className="pointer-events-none px-0.5 text-muted-foreground" aria-hidden="true"><TextAa size={18} /></span>
        <button
          onClick={incFont}
          disabled={fontStep === maxStep}
          aria-label="Increase text size"
          title="Larger text"
          className="grid h-9 w-9 place-items-center rounded-r-full text-foreground transition-colors hover:bg-accent disabled:opacity-40"
          data-testid="display-font-increase"
        ><Plus size={16} weight="bold" /></button>
      </div>
      <button
        onClick={toggleDark}
        aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        title={dark ? "Light mode" : "Dark mode"}
        className="grid h-9 w-9 place-items-center rounded-full border border-border bg-card text-foreground transition-colors hover:bg-accent"
        data-testid="display-theme-toggle"
      >{dark ? <Sun size={18} weight="fill" /> : <Moon size={18} />}</button>
    </div>
  );
}
